import keyMirror from 'react-utils/keyMirror';
import { createAction, createRequestTypes, createRequestActions } from './utils';
export const PortalSettingsActionTypes = keyMirror({
  LOAD_PORTAL_SETTING: null
});
export const FETCH_PORTAL_SETTING = 'FETCH_PORTAL_SETTING';
export const FetchPortalSettingActionTypes = createRequestTypes(FETCH_PORTAL_SETTING);
export const FetchPortalSetting = createRequestActions(FetchPortalSettingActionTypes);
export const loadPortalSetting = portalSetting => createAction(PortalSettingsActionTypes.LOAD_PORTAL_SETTING, {
  data: portalSetting
});